const DataLoaderFailed = () => {
    return (
        <div className="container-fluid text-center my-5 py-3">
            <i className="bi bi-emoji-dizzy display-1 mb-2"></i>
            <h1 className="display-5 fw-bold px-2 mt-2 mb-0">Oops</h1>

            <p className="fs-3 px-2">Seems something went wrong... please try again.</p>
        </div>
    )
}

export default DataLoaderFailed;
